import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="theme-toggle">
      <button 
        class="theme-switch"
        (click)="themeService.toggleTheme()"
        [attr.aria-label]="themeService.isDark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
        title="{{ themeService.isDark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro' }}">
        
        <div class="switch-track" [class.dark]="themeService.isDark()">
          <div class="switch-thumb" [class.dark]="themeService.isDark()">
            <i class="switch-icon fas" [class.fa-sun]="!themeService.isDark()" [class.fa-moon]="themeService.isDark()"></i>
          </div>
        </div>
        
        <span class="theme-label">
          {{ themeService.isDark() ? 'Oscuro' : 'Claro' }}
        </span>
      </button>
    </div>
  `,
  styles: [`
    .theme-toggle {
      display: flex;
      align-items: center;
    }

    .theme-switch {
      background: none;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem;
      border-radius: 8px;
      transition: all 0.2s ease;

      &:hover {
        background: var(--gray-100);
      }
    }

    .switch-track {
      width: 3rem;
      height: 1.5rem;
      background: var(--gray-300);
      border-radius: 12px;
      position: relative;
      transition: all 0.3s ease;
      box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);

      &.dark {
        background: var(--primary-color);
      }
    }

    .switch-thumb {
      width: 1.25rem;
      height: 1.25rem;
      background: white;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 0.125rem;
      transform: translateY(-50%);
      transition: all 0.3s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;

      &.dark {
        left: calc(100% - 1.375rem);
      }
    }

    .switch-icon {
      font-size: 0.75rem;
      transition: all 0.3s ease;

      &.fa-sun {
        color: #F59E0B;
      }

      &.fa-moon {
        color: #22C55E;
      }
    }

    .theme-label {
      font-size: 0.875rem;
      font-weight: 500;
      color: var(--gray-700);
      user-select: none;
    }

    // Dark theme styles
    :global(.dark-theme) {
      .theme-switch {
        &:hover {
          background: var(--gray-800);
        }
      }

      .theme-label {
        color: var(--gray-300);
      }
    }
  `]
})
export class ThemeToggleComponent {
  themeService = inject(ThemeService);
}